import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

import { StripedDataTableWrapper } from '@/components/shared/components/common.StyledComponents';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
`;

export const PageTitle = styled.h1`
    font-size: ${rem(28)};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.greyscale.gray50};
    margin: 0;
    padding: 0;
`;

export const TableWrapper = styled(StripedDataTableWrapper)`
    display: flex;
    flex-direction: column;
    gap: 8px;

    /* Stripe by applicant instead of by row, so a multi-product applicant's rows share one color.
       Each rule matches the base even-row rule's specificity, so source order decides. */
    && .p-datatable .p-datatable-tbody > tr:nth-of-type(even) {
        background: ${({ theme }) => theme.colors.greyscale.white};
    }
    && .p-datatable .p-datatable-tbody > tr.alternate-applicant {
        background: ${({ theme }) => theme.colors.greyscale.gray2_5};
    }
    && .p-datatable .p-datatable-tbody > tr.hovered-row {
        background-color: #f3f4f6;
        cursor: pointer;
    }
`;
